<template>
  <div class="px-8">
    <v-col cols="12">
      <target-field
        :filter-id="datas.filterId"
        :old-re-query="datas.reQuery"
        :editable="editable"
        @input="bindValue($event, 'reQuery')" />
    </v-col>
    <v-col><v-divider /></v-col>
    <v-col cols="12">
      <duration-field
        :old-duration="datas.duration"
        :editable="editable"
        @input="bindValue($event, 'duration')" />
    </v-col>
    <v-col><v-divider /></v-col>
    <v-col cols="12">
      <templates-field
        :old-templates="datas.templates"
        :editable="editable"
        @input="bindValue($event, 'templates')" />
    </v-col>
    <v-col><v-divider /></v-col>
  </div>
</template>

<script>
import TargetField from './TargetField.vue'
import DurationField from './DurationField.vue'
import TemplatesField from './TemplatesField.vue'

export default {
  components: {
    TargetField,
    DurationField,
    TemplatesField
  },
  props: {
    datas: {
      type: Object,
      required: true
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      form: {
        reQuery: true,
        duration: {},
        templates: []
      }
    }
  },
  methods: {
    bindValue (val, field) {
      this.form[field] = val
      this.returnValue()
    },
    returnValue () {
      this.$emit('input', {
        filterId: this.datas.filterId,
        ...this.form
      })
    }
  }
}
</script>
